/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityPrivacyPolicyOverrideItem } from './ControlEntityPrivacyPolicyOverrideItem';
import {
    ControlEntityPrivacyPolicyOverrideItemFromJSON,
    ControlEntityPrivacyPolicyOverrideItemFromJSONTyped,
    ControlEntityPrivacyPolicyOverrideItemToJSON,
} from './ControlEntityPrivacyPolicyOverrideItem';

/**
 * 
 * @export
 * @interface ControlEntityPrivacyPolicyOverrideRequest
 */
export interface ControlEntityPrivacyPolicyOverrideRequest {
    /**
     * 
     * @type {{ [key: string]: ControlEntityPrivacyPolicyOverrideItem; }}
     * @memberof ControlEntityPrivacyPolicyOverrideRequest
     */
    privacy_policy_override: { [key: string]: ControlEntityPrivacyPolicyOverrideItem; };
}

/**
 * Check if a given object implements the ControlEntityPrivacyPolicyOverrideRequest interface.
 */
export function instanceOfControlEntityPrivacyPolicyOverrideRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "privacy_policy_override" in value;

    return isInstance;
}

export function ControlEntityPrivacyPolicyOverrideRequestFromJSON(json: any): ControlEntityPrivacyPolicyOverrideRequest {
    return ControlEntityPrivacyPolicyOverrideRequestFromJSONTyped(json, false);
}

export function ControlEntityPrivacyPolicyOverrideRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityPrivacyPolicyOverrideRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'privacy_policy_override': (mapValues(json['privacy_policy_override'], ControlEntityPrivacyPolicyOverrideItemFromJSON)),
    };
}

export function ControlEntityPrivacyPolicyOverrideRequestToJSON(value?: ControlEntityPrivacyPolicyOverrideRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'privacy_policy_override': (mapValues(value.privacy_policy_override, ControlEntityPrivacyPolicyOverrideItemToJSON)),
    };
}

